<div class="row" style="margin-bottom: 100px;" *ngIf="!loader">
  <div class="col-sm-12" *ngIf="showStep1">
    <div class="content">
      <h1>New business creation (step 1 of 4)</h1>
      <div class="options">
        <div class="row">
          <div class="sub_headingt">
          <h3>Choose the kind of business
          </h3>
          </div>
          <div class="col-6" *ngFor="let item of businessTypeData; let i = index">
        <mat-card appearance="outlined"  (click)="changeBusinessType(i)">
         <div
          class="option" 
          >
          <img [src]="item.assetUrl" alt="" />
          <div *ngIf="item.isSelected == 1" class="tick_opklads">
            <!-- <i class="fa fa-check" aria-hidden="true"></i> -->
            <mat-icon
              class="material-icons-outlined"
              class="mb-1"
              style="color: #fff"
              >check</mat-icon
            >
          </div>
          <h3>{{ item.title }}</h3>
          <!-- <div class="checkmark">✔️</div> -->
        </div>
      </mat-card>
    </div>
    </div>
      </div>


      <h2 *ngIf="businessTypeData[1].isSelected == 1">Select service provider gender
      </h2>
      <div class="grid-options service-type" *ngIf="businessTypeData[1].isSelected == 1" style="border-bottom: none;">
        <div class="row">
          <div class="col-6" *ngFor="let item of professsionalGender; let i= index">
            <mat-card appearance="outlined" (click)="selectProfessionalGender(i)">
          <div class="grid-item"  >
          <img [src]="item.assetUrl" alt="" />
          <div *ngIf="item.isSelected == true" class="tick_opklads">
            <!-- <i class="fa fa-check" aria-hidden="true"></i> -->
            <mat-icon
              class="material-icons-outlined"
              class="mb-1"
              style="color: #fff"
              >check</mat-icon
            >
          </div>
        <h3>{{ item.title }}</h3>
        </div>
      </mat-card>
      </div>
      </div>
      </div>
      <h2>Select the type of service
      </h2>
      <div class="grid-options service-type">
        <div class="row">
          <div class="col-6"  *ngFor="let item of toShowServiceTemplates; let i= index">
         
            <div class="grid-item" (click)="selectServiceType(i)">
              <mat-card appearance="outlined" [ngClass]="{'make-disabled': checkDisabilityForCheckBox(item)}">
          <img [src]="item.icon_url" alt="" />
          <div *ngIf="item.isSelected == true" class="tick_opklads">
            <!-- <i class="fa fa-check" aria-hidden="true"></i> -->
            <mat-icon
              class="material-icons-outlined"
              class="mb-1"
              style="color: #fff"
              >check</mat-icon
            >
          </div>
        <h3>{{ item.name }}</h3>
      </mat-card>
        </div>


      </div>
      </div>

      </div>
      <div class="footer">
        <button (click)="cancel()" mat-button style="font-size: 16px;"> Cancel</button>

        <button
        (click)="onClickNext(1)"
        [disabled]="checkServicesSelected() || isGenderSelected()"
      mat-flat-button
      color="accent"
      class="next"
    >
      Next
    </button>
      </div>
    </div>
    </div>
  <div class="col-sm-8" *ngIf="showStep2">
    <div class="content">
      <h1>New business creation (step 2 of 4)
      </h1>
      <div class="options">
        <div class="row">
          <div class="sub_headingt">
            <h3>Mode of offering the service

            </h3>
            </div>
          <div class="col-6"  *ngFor="let item of serviceTypeData; let i = index">
            <mat-card appearance="outlined" (click)="selectServiceTypeData(i)" >
        <div
          class="option"
         
          
        >
          <img [src]="item.assetUrl" alt="" />
          <div *ngIf="item.isSelected == true" class="tick_opklads">
            <!-- <i class="fa fa-check" aria-hidden="true"></i> -->
            <mat-icon
              class="material-icons-outlined"
              class="mb-1"
              style="color: #fff"
              >check</mat-icon
            >
          </div>
          <h3>{{ item.title }}</h3>
          <!-- <div class="checkmark">✔️</div> -->
        </div>
      </mat-card>
      </div>
      </div>
        
      </div>

      <h2>Business type based on target customer
      </h2>
      <div class="grid-options service-type">
       
        <div class="row">
          <div class="col-6" *ngFor="let item of serviceTypeGender; let i= index">
            <mat-card appearance="outlined" (click)="selectServiceTypeGender(i)">
        <div class="grid-item"  >
          <img [src]="item.assetUrl" alt="" />
          <div *ngIf="item.isSelected == true" class="tick_opklads">
            <!-- <i class="fa fa-check" aria-hidden="true"></i> -->
            <mat-icon
              class="material-icons-outlined"
              class="mb-1"
              style="color: #fff"
              >check</mat-icon
            >
          </div>
        <h3>{{ item.title }}</h3>
        </div>
      </mat-card>
      </div>
      </div>

      </div>
      <div class="footer">
        <button mat-button style="font-size: 16px;" (click)="onClickBack(2)"><mat-icon>arrow_back</mat-icon> Back</button>

        <button
        (click)="onClickNext(2)"
        [disabled]="checkServiceTypeSelected() ||checkServiceTargetTypeSelected()"
      mat-flat-button
      color="accent"
      class="next"
    >
      Next
    </button>
      </div>
    </div>
    </div>
    <div class="col-sm-12" *ngIf="showStep3">
      <div class="content" style="padding-bottom: 40px;border-bottom: 1px solid #dadada;">
        <h1>New business creation (step 3 of 4)</h1>
        <div class="sub_headingt">
          <h3>Vital information of the business/service</h3>
          </div>
        <div>
          <div class="form-container add-bottom-margin">
           
            <!-- <h4>Name</h4> -->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Business/service name</mat-label>
              <input
              [(ngModel)]="newBusinessObj.name"
              placeholder="Enter name"
                matInput
                #input
              />
            </mat-form-field>
          </div>

          <!-- <div class="form-container add-bottom-margin">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Business contact number</mat-label>
              <input
              smNumericOnly
              maxlength="10"
              type="tel"
              [(ngModel)]="newBusinessObj.phone"
              placeholder="Enter phone number"
                matInput
                #input
              />
            </mat-form-field>
          </div> -->

          <div class="c_sectionmj">
            <div class="form-container add-bottom-margin">
            <div class="row">
             <div class="col-sm-3">
              <mat-form-field appearance="outline" class="country-code">
                <mat-label>Country Code</mat-label>
                <mat-select
                [(ngModel)]="entityCountryCode"
                required
                (selectionChange)="onCountrySelected($event)"
              >
                <mat-select-trigger>
                  {{ entityCountryCode.flag }} {{ entityCountryCode.name }}
                      {{ "(" + entityCountryCode.dial_code + ")" }}
                </mat-select-trigger>
                
                <mat-option>
                  <ngx-mat-select-search
                    noEntriesFoundLabel="no results found"
                    name="countrysearch"
                    placeholderLabel="Enter country name"
                    [formControl]="searchString"
                    (keyup)="onKey()"
                  ></ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let country of countryList" [value]="country">
                  {{ country.flag }} {{ country.name }}
                  {{ "(" + country.dial_code + ")" }}
                </mat-option>
              </mat-select>
              </mat-form-field>
           </div>
           <div class="col-sm-9">
             <mat-form-field appearance="outline" class="phone-number">
               <mat-label>Business contact number</mat-label>
               <input matInput type="tel" placeholder="Enter business contact number"  smNumericOnly
               minLength="3"
                  maxlength="17"
               type="tel"
               [(ngModel)]="newBusinessObj.phone">
             </mat-form-field>
             </div>
           </div>
           </div>
          </div>



          <div class="form-container add-bottom-margin">
            <!-- <h4>Description</h4> -->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Business/service description
              </mat-label>
              <textarea
              [maxLength]="1000"
              [(ngModel)]="newBusinessObj.entityDesc"
              placeholder="Enter details
              "
                matInput
              ></textarea>
            </mat-form-field>
          </div>
          <div class="form-container add-bottom-margin">
            <!-- <h4>Email (optional)</h4> -->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Business E-mail (optional)
              </mat-label>

              <input
              [(ngModel)]="newBusinessObj.email"
              placeholder="Enter E-mail
              "
                matInput
                #input
              />
            </mat-form-field>
          </div>
          <div class="form-container add-bottom-margin">
            <!-- <h4>Email (optional)</h4> -->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Business website (optional)
              </mat-label>

              <input
              [(ngModel)]="newBusinessObj.business_website_address"
              placeholder="Enter E-mail
              "
                matInput
                #input
              />
            </mat-form-field>
          </div>
          <div class="form-container add-bottom-margin" >
            <!-- <h4>Owner name</h4> -->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Owner name</mat-label>

              <input
              [(ngModel)]="newBusinessObj.ownerName"
              placeholder="Enter owner name"
                matInput
                #input
              />
            </mat-form-field>
          </div>

          <!-- <div class="form-container add-bottom-margin" >
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Owner phone number
              </mat-label>
              <input
              smNumericOnly
              maxlength="10"
              type="tel"
              [(ngModel)]="newBusinessObj.ownerPhone"
              placeholder="Enter owner phone number
              "
                matInput
                #input
              />
            </mat-form-field>
          </div> -->



          <div class="c_sectionmj">
            <div class="form-container add-bottom-margin">
            <div class="row">
             <div class="col-sm-3">
              <mat-form-field appearance="outline" class="country-code">
                <mat-label>Country Code</mat-label>
                <mat-select
                [(ngModel)]="ownerCountryCode"
                required
                (selectionChange)="onCountrySelected($event)"
              >
                <mat-select-trigger>
                  {{ ownerCountryCode.flag }} {{ ownerCountryCode.name }}
                      {{ "(" + ownerCountryCode.dial_code + ")" }}
                </mat-select-trigger>
                
                <mat-option>
                  <ngx-mat-select-search
                    noEntriesFoundLabel="no results found"
                    name="countrysearch"
                    placeholderLabel="Enter country name"
                    [formControl]="searchString"
                    (keyup)="onKey()"
                  ></ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let country of countryList" [value]="country">
                  {{ country.flag }} {{ country.name }}
                  {{ "(" + country.dial_code + ")" }}
                </mat-option>
              </mat-select>
              </mat-form-field>
           </div>
           <div class="col-sm-9">
             <mat-form-field appearance="outline" class="phone-number">
               <mat-label>Owner phone number</mat-label>
               <input  smNumericOnly
               minLength="3"
                  maxlength="17"
               type="tel"
               [(ngModel)]="newBusinessObj.ownerPhone"
               placeholder="Enter owner phone number
               "
                 matInput
                 #input>
             </mat-form-field>
             </div>
           </div>
           </div>
          </div>


          <div class="form-container add-bottom-margin" >
            <!-- <h4>Registration number</h4> -->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Registration number (optional)
              </mat-label>

              <input
              [(ngModel)]="newBusinessObj.referenceNo"
              placeholder="Enter registration number
              "
                matInput
                #input
              />
            </mat-form-field>
          </div>
          <div class="form-container add-bottom-margin" >
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Registration type (optional)

              </mat-label>

              <input
              placeholder="The type of registration

              "
                matInput
                #input
              />
            </mat-form-field>
          </div>

          <div class="form-container" >
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Currency: {{countryInfo ? countryInfo.currency : 'INR' }} ({{countryInfo ? countryInfo.currencySymbol : '₹' }})

              </mat-label>

              <input disabled
              placeholder="The type of registration 

              "
                matInput
                #input
              />
            </mat-form-field>
          </div>


        </div>
        
        </div>
          <div class="footer">
            <button mat-button style="font-size: 16px;" (click)="onClickBack(3)"><mat-icon>arrow_back</mat-icon> Back</button>
    
            <button
            (click)="onClickNext(3)"
            [disabled]="checkForm()"
          mat-flat-button
          color="accent"
          class="next"
        >
          Next
        </button>
          </div>
    </div>
    <div class="col-sm-12" *ngIf="showStep4">
      <div class="content" style="padding-bottom: 40px;
    border-bottom: 1px solid #dadada;">
        <h1>New business creation (step 4 of 4)</h1>
        <div class="sub_headingt">
          <h3>The business/service provider location</h3>
          </div>



        <div class="map-holder">
          <div #mapContainer id="map-container" style="height: 500px; width: 100%;"></div>

        </div>
        <div class="map-form-holder">
          <!-- <h4>Address</h4> -->
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Address which people would see</mat-label>
            <input
            [(ngModel)]="formattedAddress"

            #autocomplete id="autocomplete" type="text" placeholder="Enter address"
              matInput
              #input
            />
          </mat-form-field>
        </div>
      </div>
      <div class="footer">
        <button mat-button style="font-size: 16px;" (click)="onClickBack(4)"><mat-icon>arrow_back</mat-icon> Back</button>

        <button
      (click)="onSubmit()"
      [disabled]="!formattedAddress"
      mat-flat-button
      color="accent"
      class="next"
    >
      Save
    </button>
      </div>
    </div>
       
</div>
